module.exports = __webpack_public_path__ + "static/media/jpg-icon.2fb488f5.svg";